<div>
    <table mat-table class="full-width-table striped-table widget-table widget-table-hoverable widget-table-row" aria-label="Documents">
        <!-- Title Column -->
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Title</th>
            <td mat-cell *matCellDef="let library">
                <app-document-link title="{{ library.title | shorten:24 }}"
                    (onclick)="navigation.navigateToDocuments(library, customerSpaceId)" />
            </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
                <app-widget-chip *ngIf="0">New</app-widget-chip>
            </td>
        </ng-container>

        <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick($event, row)"></tr>
    </table>
</div>